module.exports = __webpack_public_path__ + "static/media/gal0008.c4f16d26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal00/gal0008.jpg
// module id = 397
// module chunks = 0